import React, { useEffect, useState, useRef } from 'react'
import WidgetHeader from '../../../../components/Widget/Header';
import { FormattedDate, FormattedTime } from 'react-intl'
import BookingRejectModal from 'components/AvailabilityDataTable/components/BookingRejectModal'
import { Button } from '@arnsbogroup/react-voicearchive'

const BookingRequestsWidget = ({widget}) => {
  const mounted = useRef(false);
  
  const [bookings, setBookings] = useState([]);
  const [supplierId, setSupplierId] = useState(null);
  const [title, setTitle] = useState('');
  const [showBookingRejectModal, setShowBookingRejectModal] = useState(false)
  const [modalBookingDetails, setModalBookingDetails] = useState({id: null, action: () => {}})

  useEffect(() => {
    mounted.current = true;
    fetch('supplierdashboard/Booking_Requests')
    .then((response) => response.json())
    .then(({data}) => {
      if (mounted.current) {
        if (data.bookings.bookingEntries) {
          setBookings(data.bookings.bookingEntries);
          setSupplierId(data.bookings.supplier.uid);
        }
      }
    });

    setTitle(widget.widgetId.replace(/_/g, ' '));

    return () => {
      mounted.current = false;
    };
  }, [])

  useEffect(() => {
    if (modalBookingDetails.id && modalBookingDetails.action) {
        modalBookingDetails.action()
    }
  }, [modalBookingDetails])

  const bookingAction = (action, bookingId, oldBookings, message = '') => {
    const body = JSON.stringify({
      [action] : 1,
      message: message
    })

    fetch(`/rest/v2/supplier/${supplierId}/booking/${bookingId}`, { method: 'PUT', body, credentials: 'same-origin' })
      .then((response) => response.json())
      .then((json) => {
        setBookings(oldBookings.map((event) => {
          if ('bookingDetails' in event && event.bookingDetails.uid == json.uid) {
            event.bookingDetails = json
            return event
          }else if (!event.uid || event.uid == json.uid) {
            return json
          } else {
            return event
          }
        }))
      })
      .catch((error) => toastr.error(error))
  }

  const getStartDate = (booking) => {
    const value = new Date(booking["dateStart"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const getEndDate = (booking) => {
    const value = new Date(booking["dateEnd"] * 1000)
    return <div>
      <span className="mr-1">
        <FormattedDate value={value} />
      </span>
      <span>
        <FormattedTime value={value} />
      </span>
    </div>
  };

  const widget_id = `ID_${widget.widgetId}`;
  
  return (
    <li className="bg-white border m-4 shadow rounded border-gray-400" key={widget_id} id={widget_id}>
      <WidgetHeader widget={widget} widgetTitle={title} />

      <table className="w-full table-fixed text-xs">
        <thead>
          <tr className="font-medium">
            <td className="border-b px-4 py-2"></td>
            <td className="border-b px-4 py-2">Start</td>
            <td className="border-b px-4 py-2">End</td>
            <td className="truncate border-b px-4 py-2">Message</td>
          </tr>
        </thead>
        <tbody>
          {bookings.map((booking) => (
            <tr className="hover:bg-gray-200" >
              <td className="border-b px-4 py-2 space-y-1">
                {booking.accepted > 0 ? (
                  <>
                    <i className="text-green-500 fa fa-circle mr-2" title="Accepted"></i>
                    <span>Accepted</span>
                  </>
                ) : ( booking.rejected > 0 ? (
                    <>
                      <i className="text-red-500 fa fa-circle mr-2" title="Rejected"></i>
                      <span>Rejected</span>
                    </>
                  ) : (
                    <>
                      <Button size="xs" onClick={() => bookingAction('accept', booking.uid, bookings)} >
                        Accept
                      </Button>
                      <Button variant="outline" size="xs" state="negative" onClick={() =>setModalBookingDetails({id: booking.uid, action: () => setShowBookingRejectModal(true)})} >
                        Reject
                      </Button>
                    </>
                  )
                )}
              </td>
              <td className="border-b px-4 py-2">
                {getStartDate(booking)}
              </td>
              <td className="border-b px-4 py-2">
                {getEndDate(booking)}
              </td>
              <td className="border-b px-4 py-2 text-right">
                {booking.message}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <BookingRejectModal show={showBookingRejectModal} onClose={() => setShowBookingRejectModal(false)} onReject={ (message) => {
          bookingAction('reject', modalBookingDetails.id, bookings, message)
          setShowBookingRejectModal(false)
        }} 
      />
    </li>
  );

}

export default BookingRequestsWidget;
